import Alpine from "alpinejs";
import { PROMOTION_EVENTS } from "@app/lib/events";


type Config = {
    slot?: string,
    creativeName?: string,
    promotionName?: string,
    promotionId?: string,
}

type Details = {
    creative_name?: string
    creative_slot?: string
    promotion_name?: string
    promotion_id?: string
}

Alpine.data("banner", (config: Config) => ({
    promotionDetails: {} as Details,
    init() {
        this.promotionDetails = this.parseDetails(config)
        this.$dispatch(PROMOTION_EVENTS.VIEW, this.promotionDetails)
        Alpine.bind(this.$root, this.root);
    },
    parseDetails(config: Config): Details {
        const slot = `${config.creativeName}/slot_${config.slot}`
        const payload = {
            creative_name: config.creativeName,
            creative_slot: slot,
            promotion_name: config?.promotionName ?? config.creativeName,
            promotion_id: config?.promotionId ?? config.creativeName,
        }
        return payload
    },
    root: {
        ['@click']() {
            const slot = this.$el?.dataset?.slot ?? 1
            this.$dispatch(PROMOTION_EVENTS.SELECT, {
                ...this.promotionDetails,
                creative_slot: `${this.promotionDetails.creative_name}/slot_${slot}`
            })
        }
    }
}))